import { UseIndividualsConfig } from '../types/hookTypes';
import useActiveEntityData from './useActiveEntityData';
import useIndividualsMeta, { defaultConfig } from './useIndividualsMeta';

const useActiveIndividualsMeta = (
	config: UseIndividualsConfig = defaultConfig,
	identifier: string | null | undefined = undefined
) => {
	const { activeItem } = useActiveEntityData();

	const res = useIndividualsMeta(activeItem?._id, config, identifier);

	return res;
};

export default useActiveIndividualsMeta;
